export const AGE_LABELS = [
  "Éveil",
  "Mini-Poussin(e)",
  "Poussin(e)",
  "Benjamin(e)",
  "Minime",
  "Cadet(te)",
  "Junior",
  "Sénior",
  "Vétéran",
  "ADULT",
  "U-21",
  "U-18",
  "U-16",
  "U-14",
  "U-12",
  "U-10",
  "U-8",
];

export const DISCIPLINE_OPTIONS = [
  "Judo",
  "Jujitsu",
  "Ne-Waza",
  "Para Judo",
  "Judo Adapté",
  "Taïso",
  "Kendo",
  "Naginata",
  "Iaïdo",
  "Kyudo",
  "Autre",
];

export const EVENT_TYPE_OPTIONS = [
  "Compétition",
  "Animation",
  "Stage & Regroupement Technique",
  "Passage de Grade",
  "Entraînement Départemental",
  "Stage Club",
  "Stage Sportif Départemental",
  "Stage Sportif Régional",
  "Tournoi Interclubs",
  "Cours commun Club",
  "Formation",
  "Formation SNR",
  "Réunion",
  "Assemblée Générale",
  "Kagami Biraki",
  "Séminaire",
  "Culture Judo",
  "Autre",
];

export const EVENT_LEVEL_OPTIONS = [
  "Club",
  "Départemental",
  "Inter-zones",
  "Régional",
  "National",
  "International",
];

export const EMPTY_EVENT = {
  titre: "",
  description: "",
  start: "",
  end: "",
  discipline_event: "",
  type_event: "",
  level_event: "",
  cate_event: "",
  lieu_event: "",
  horaire_event: "",
  photo_url: "",
  agenda_url: "",
  suivi_event: "",
  organisateur: "",
  is_active: true,
};

export const PAGE_SIZE = 20;